import { useAuth0 } from "@auth0/auth0-react"
import { useCallback, useState } from "react"

export const useGetOrgSessionCount = (chosenOrg) => {
	const { getAccessTokenSilently } = useAuth0()

	const [data, setData] = useState(null)
	const [isLoading, setIsLoading] = useState(false)

	const getSessionCount = useCallback(async () => {
		setIsLoading(true)
		return fetch(process.env.REACT_APP_SESSION_ADDR + "/api/v2/org/" + chosenOrg.id + "/sessioncount", {
			method: "GET",
			headers: new Headers({
				"authorization": "Bearer " + (await getAccessTokenSilently()),
				"Content-Type": "application/json"
			})
		})
			.then((response) => {
				if (response.ok) {
					console.log("Get session count successfully!")
					return response.json()
				} else {
					throw new Error("Something went wrong")
				}
			})
			.then((res) => {
				setData(res ? res : 0)
			})
			.catch((err) => {
				console.log(err)
			})
			.finally(() => {
				setIsLoading(false)
			})
	}, [getAccessTokenSilently])

	return { data, isLoading, getSessionCount }
}
